const state = {
    countries: []
}

const actions = {
    async loadEnabledCountries({ commit }) {
        window.axios({
            url: "/actions/checkout-module/shipping/get-countries",
            method: "GET"
        }).then(result => {
            if (result.status === 200 && result?.data) {
                // Update cart count to show in navigation
                commit("LOAD_ENABLED_COUNTRIES", result.data);
            } else {
                console.warn('Could not retrieve countries.', result);
            }
        }).catch(error => {
            console.warn('Could not connect to controller.', error);
        });
    }
}

const mutations = {
    LOAD_ENABLED_COUNTRIES(state, payload) {
        state.countries = payload;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
